<template>
  <div class="onboarding-wrapper">
    <div class="container">
      <div class="card">
        <h2>{{ $t("app.profil.tutorial.title") }}</h2>
        <p>
          {{ $t("app.profil.tutorial.desc") }}
        </p>
        <div class="video-wrapper">
          <iframe
            :src="videoUrl"
            frameborder="0"
            allowfullscreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="card">
        <h2>{{ $t("app.profil.onboarding.title") }}</h2>
        <p>
          {{ $t("app.profil.onboarding.desc") }}
        </p>
        <Button :disabled="!canWriteCampaignAndSpaces(roles)" class="primary icon icon-left onboarding-btn" :label="$t('app.profil.onboarding.restart')" icon="bi-arrow-counterclockwise" @click="appStore.restartOnboarding()" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { canWriteCampaignAndSpaces } from "@/composables/permissions";
import { useRoles } from "@/queries/user.query";
import { useAppStore } from "@/stores/app.js";
const { t } = useI18n();

const appStore = useAppStore();
const { data: roles } = useRoles();

const videoId = t('app.profil.tutorial.video').split('v=')[1];
const videoUrl = computed(() =>
  `https://www.youtube.com/embed/${videoId}?controls=1`
);
</script>
